import mutationsTypes from '@/vuex/vinculos-documento/mutations-types.js'
const types = {
  ...mutationsTypes,
  INICIALIZAR_DADOS_VINCULOS_DOCUMENTO: 'INICIALIZAR_DADOS_VINCULOS_DOCUMENTO',
  GET_DOCUMENTO_AGREGADOR: 'GET_DOCUMENTO_AGREGADOR',
  SET_DOCUMENTO_AGREGADOR: 'SET_DOCUMENTO_AGREGADOR',
  GET_LISTA_VINCULOS_DOCUMENTO: 'GET_LISTA_VINCULOS_DOCUMENTO',
  DESAPENSAR_DOCUMENTO: 'DESAPENSAR_DOCUMENTO',
  DESANEXAR_DOCUMENTO: 'DESANEXAR_DOCUMENTO'
}

export default types
